import { Link } from '@tanstack/react-router'
import { LegalLayout } from '~/components/marketing/legal-layout'
import '~/styles/marketing.css'

export const TermsPage = () => (
  <LegalLayout title="Termos de Uso" updatedAt="2 de dezembro de 2025">
    <h2>1. Aceitação dos Termos</h2>
    <p>
      Ao acessar ou utilizar a plataforma Planno (&ldquo;Plataforma&rdquo;), você concorda em
      cumprir e estar vinculado a estes Termos de Uso. Se você não concordar com qualquer parte
      destes termos, não poderá acessar ou utilizar nossos serviços.
    </p>
    <p>
      Estes Termos constituem um acordo legal entre você e o Planno. Recomendamos que você leia
      atentamente todo o documento antes de utilizar a Plataforma.
    </p>

    <h2>2. Definições</h2>
    <p>Para fins destes Termos de Uso:</p>
    <ul>
      <li>
        <strong>&ldquo;Plataforma&rdquo;</strong> refere-se ao sistema Planno, incluindo o site,
        aplicativo e todos os serviços relacionados.
      </li>
      <li>
        <strong>&ldquo;Usuário&rdquo;</strong> refere-se a qualquer pessoa que acessa ou utiliza a
        Plataforma.
      </li>
      <li>
        <strong>&ldquo;Conta&rdquo;</strong> refere-se ao cadastro individual do Usuário na
        Plataforma.
      </li>
      <li>
        <strong>&ldquo;Conteúdo do Usuário&rdquo;</strong> refere-se a todos os arquivos, dados,
        informações, textos, imagens, fotos e demais materiais enviados pelo Usuário à Plataforma.
      </li>
      <li>
        <strong>&ldquo;Serviços&rdquo;</strong> refere-se às funcionalidades oferecidas pela
        Plataforma, incluindo gestão de arquivos, cronogramas, visitas de obra e colaboração de
        equipe.
      </li>
    </ul>

    <h2>3. Cadastro e Conta</h2>
    <h3>3.1 Requisitos</h3>
    <p>
      Para utilizar a Plataforma, você deve ter pelo menos 18 (dezoito) anos de idade e capacidade
      civil plena para celebrar contratos. Ao criar uma conta, você declara que atende a esses
      requisitos.
    </p>
    <h3>3.2 Informações de Cadastro</h3>
    <p>
      Você concorda em fornecer informações verdadeiras, precisas e completas durante o processo de
      cadastro e em manter essas informações atualizadas. O Planno reserva-se o direito de suspender
      ou encerrar contas que contenham informações falsas ou enganosas.
    </p>
    <h3>3.3 Segurança da Conta</h3>
    <p>
      Você é responsável por manter a confidencialidade de suas credenciais de acesso (e-mail e
      senha) e por todas as atividades realizadas em sua conta. Caso suspeite de uso não autorizado,
      notifique-nos imediatamente.
    </p>

    <h2>4. Descrição do Serviço</h2>
    <h3>4.1 Funcionalidades</h3>
    <p>
      O Planno é uma plataforma de gestão de projetos desenvolvida especialmente para escritórios de
      arquitetura e profissionais da construção civil. A Plataforma oferece:
    </p>
    <ul>
      <li>Gestão de arquivos com suporte a diversos formatos</li>
      <li>Cronograma visual com gráficos de Gantt interativos</li>
      <li>Documentação de visitas de obra com fotos e anotações</li>
      <li>Colaboração em equipe com sincronização em tempo real</li>
      <li>Funcionalidade offline com sincronização automática</li>
    </ul>
    <h3>4.2 Planos e Assinaturas</h3>
    <p>
      A Plataforma oferece planos gratuitos com funcionalidades limitadas e planos pagos com
      recursos adicionais. As condições específicas de cada plano estão disponíveis em nossa página
      de preços.
    </p>

    <h2>5. Uso Aceitável</h2>
    <p>Ao utilizar a Plataforma, você concorda em NÃO:</p>
    <ul>
      <li>Violar qualquer lei ou regulamento aplicável</li>
      <li>Enviar conteúdo ilegal, difamatório, obsceno ou que viole direitos de terceiros</li>
      <li>Utilizar a Plataforma para fins fraudulentos ou enganosos</li>
      <li>Tentar acessar áreas restritas da Plataforma sem autorização</li>
      <li>Realizar engenharia reversa, descompilar ou desmontar qualquer parte da Plataforma</li>
      <li>Transmitir vírus, malware ou qualquer código malicioso</li>
      <li>Interferir no funcionamento normal da Plataforma ou sobrecarregar nossos sistemas</li>
      <li>Coletar dados de outros usuários sem consentimento</li>
      <li>Utilizar a Plataforma para enviar spam ou comunicações não solicitadas</li>
    </ul>

    <h2>6. Propriedade Intelectual</h2>
    <h3>6.1 Conteúdo do Usuário</h3>
    <p>
      Você mantém todos os direitos de propriedade sobre o Conteúdo do Usuário enviado à Plataforma.
      O Planno não reivindica propriedade sobre seus arquivos, projetos, fotos ou qualquer outro
      material que você enviar.
    </p>
    <h3>6.2 Licença para Operação</h3>
    <p>
      Ao enviar Conteúdo do Usuário, você concede à Planno uma licença limitada, não exclusiva e
      revogável para armazenar, processar e exibir esse conteúdo exclusivamente com o objetivo de
      fornecer os Serviços a você e aos membros da sua equipe autorizados.
    </p>
    <h3>6.3 Propriedade da Plataforma</h3>
    <p>
      A Plataforma, incluindo seu design, código, funcionalidades, marca e logotipo, são de
      propriedade exclusiva do Planno e estão protegidos por leis de propriedade intelectual. Nenhum
      direito é transferido ao Usuário além do direito de uso conforme estes Termos.
    </p>

    <h2>7. Privacidade e Dados</h2>
    <h3>7.1 Política de Privacidade</h3>
    <p>
      O tratamento de seus dados pessoais é regido por nossa{' '}
      <Link to="/politica-de-privacidade">Política de Privacidade</Link>, que faz parte integrante
      destes Termos de Uso. Recomendamos a leitura atenta desse documento.
    </p>
    <h3>7.2 Dados Anonimizados</h3>
    <p>
      O Planno pode utilizar dados agregados e anonimizados para fins de análise, melhoria dos
      Serviços e geração de estatísticas. Esses dados não permitem a identificação individual dos
      Usuários.
    </p>
    <h3>7.3 LGPD</h3>
    <p>
      O Planno está comprometido em cumprir a Lei Geral de Proteção de Dados (Lei nº 13.709/2018) e
      demais legislações aplicáveis à proteção de dados pessoais no Brasil.
    </p>

    <h2>8. Pagamentos e Assinaturas</h2>
    <h3>8.1 Planos Pagos</h3>
    <p>
      Os planos pagos são cobrados conforme o ciclo de faturamento escolhido (mensal ou anual). Os
      valores e condições específicas estão disponíveis em nossa página de preços.
    </p>
    <h3>8.2 Renovação Automática</h3>
    <p>
      As assinaturas são renovadas automaticamente ao final de cada período, salvo cancelamento pelo
      Usuário antes da data de renovação. Você será notificado antes de qualquer cobrança.
    </p>
    <h3>8.3 Reembolsos</h3>
    <p>
      Solicitações de reembolso serão analisadas caso a caso. Entre em contato com nosso suporte
      para mais informações.
    </p>

    <h2>9. Cancelamento e Encerramento</h2>
    <h3>9.1 Cancelamento pelo Usuário</h3>
    <p>
      Você pode cancelar sua conta a qualquer momento através das configurações da Plataforma ou
      entrando em contato com nosso suporte.
    </p>
    <h3>9.2 Retenção de Dados</h3>
    <p>
      Após o cancelamento, seus dados serão mantidos por 30 (trinta) dias para possibilitar eventual
      reativação da conta. Após esse período, todos os dados serão permanentemente excluídos de
      nossos sistemas.
    </p>
    <h3>9.3 Encerramento pelo Planno</h3>
    <p>
      O Planno reserva-se o direito de suspender ou encerrar sua conta em caso de violação destes
      Termos de Uso, sem prejuízo de outras medidas cabíveis.
    </p>

    <h2>10. Disponibilidade do Serviço</h2>
    <h3>10.1 Melhor Esforço</h3>
    <p>
      O Planno emprega seus melhores esforços para manter a Plataforma disponível e funcionando
      corretamente. No entanto, não garantimos disponibilidade ininterrupta ou livre de erros.
    </p>
    <h3>10.2 Manutenções</h3>
    <p>
      A Plataforma pode ficar temporariamente indisponível para manutenções programadas ou
      emergenciais. Sempre que possível, notificaremos os Usuários com antecedência.
    </p>
    <h3>10.3 Modificações</h3>
    <p>
      Reservamo-nos o direito de modificar, suspender ou descontinuar funcionalidades da Plataforma
      a qualquer momento, mediante aviso prévio razoável quando aplicável.
    </p>

    <h2>11. Limitação de Responsabilidade</h2>
    <p>Na máxima extensão permitida pela lei, o Planno não será responsável por:</p>
    <ul>
      <li>Danos indiretos, incidentais, especiais ou consequenciais</li>
      <li>Perda de dados, lucros, receitas ou oportunidades de negócio</li>
      <li>Interrupções ou falhas no serviço causadas por fatores fora de nosso controle</li>
      <li>Conteúdo enviado por Usuários ou terceiros</li>
      <li>Acesso não autorizado resultante de falha do Usuário em proteger suas credenciais</li>
    </ul>
    <p>
      Em qualquer caso, a responsabilidade total do Planno estará limitada ao valor pago pelo
      Usuário nos 12 (doze) meses anteriores ao evento que deu origem à reclamação.
    </p>

    <h2>12. Alterações nos Termos</h2>
    <p>
      O Planno pode atualizar estes Termos de Uso periodicamente. Quando fizermos alterações
      significativas, notificaremos você por e-mail ou através de aviso na Plataforma.
    </p>
    <p>
      O uso continuado da Plataforma após a publicação das alterações constitui sua aceitação dos
      novos termos. Se você não concordar com as alterações, deverá descontinuar o uso da
      Plataforma.
    </p>

    <h2>13. Disposições Gerais</h2>
    <h3>13.1 Lei Aplicável</h3>
    <p>Estes Termos são regidos pelas leis da República Federativa do Brasil.</p>
    <h3>13.2 Acordo Integral</h3>
    <p>
      Estes Termos, juntamente com a Política de Privacidade, constituem o acordo integral entre
      você e o Planno em relação ao uso da Plataforma.
    </p>
    <h3>13.3 Cessão</h3>
    <p>
      Você não pode ceder ou transferir seus direitos sob estes Termos sem consentimento prévio por
      escrito do Planno. O Planno pode ceder seus direitos e obrigações a terceiros mediante
      notificação.
    </p>
    <h3>13.4 Contato</h3>
    <p>
      Para dúvidas, sugestões ou reclamações relacionadas a estes Termos de Uso, entre em contato
      conosco através do e-mail: <a href="mailto:contato@planno.app">contato@planno.app</a>.
    </p>
  </LegalLayout>
)
